import { useSyncExternalStore } from "react";

/** Tailwind's `sm` is 640 px; below it the sheet is the whole screen and the strip is one line. */
const QUERY = "(max-width: 639.98px)";

const query = (): MediaQueryList | null =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(QUERY)
    : null;

function subscribe(onChange: () => void) {
  const list = query();
  list?.addEventListener("change", onChange);
  return () => {
    list?.removeEventListener("change", onChange);
  };
}

/** True while the screen is a phone's width, and follows it when the window is turned or resized. */
export function useIsPhone(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => query()?.matches ?? false,
    () => false,
  );
}

/** Tailwind's `lg`: from here Djinn docks beside the page instead of covering it. */
const DOCK_QUERY = "(min-width: 64rem)";

const dockQuery = (): MediaQueryList | null =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(DOCK_QUERY)
    : null;

function subscribeDock(onChange: () => void) {
  const list = dockQuery();
  list?.addEventListener("change", onChange);
  return () => {
    list?.removeEventListener("change", onChange);
  };
}

/** True while the screen is wide enough for Djinn to sit beside the page. */
export function useIsDocked(): boolean {
  return useSyncExternalStore(
    subscribeDock,
    () => dockQuery()?.matches ?? false,
    () => false,
  );
}
